import RobotManage from './RobotManage';
import UserManage from './UserManage';
import SystemManage from './SystemManage';
import AuditLog from './AuditLog';

export default {
  RobotManage,
  UserManage,
  SystemManage,
  AuditLog,
};



// WEBPACK FOOTER //
// ./src/manage-modules/index.js